import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
    'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
    {
        variants: {
            variant: {
                default: 'border-transparent bg-primary text-primary-foreground',
                secondary: 'border-transparent bg-secondary text-secondary-foreground',
                destructive: 'border-transparent bg-destructive text-destructive-foreground',
                outline: 'text-foreground',
                // Score variants
                critical: 'border-red-500/20 bg-red-500/15 text-red-400',
                high: 'border-orange-500/20 bg-orange-500/15 text-orange-400',
                medium: 'border-green-500/20 bg-green-500/15 text-green-400',
                low: 'border-zinc-500/20 bg-zinc-500/15 text-zinc-400',
                // Wallet classification
                whale: 'border-blue-500/20 bg-blue-500/15 text-blue-400',
                sharp: 'border-purple-500/20 bg-purple-500/15 text-purple-400',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
);

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
    return (
        <div className={cn(badgeVariants({ variant }), className)} {...props} />
    );
}

export { Badge, badgeVariants };
